import React from 'react';
import HyperLink from 'components/Core/HyperLink';
import { WebsiteImage } from 'components/TitleDescription';
import { SimpleMenuItemContainer } from './styles';

const SimpleMenuItem = ({ type, icon, alt, title, link, target, ...otherProps }) => (
  <SimpleMenuItemContainer className="simple-menu-item" {...otherProps}>
    <HyperLink
      data-position="Header - Menu Item CTA"
      href={link}
      state={{ redirectedFromHeaderMenu: true }}
    >
      {type === 'icon-title-desc' && <WebsiteImage src={icon} alt={alt} />}
      <p>{title}</p>
    </HyperLink>
  </SimpleMenuItemContainer>
);

export default SimpleMenuItem;
